import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';

@Injectable({
    providedIn: 'root'
})
export class CoAddressService extends ApiService {


    store(body: any) {
        return super.post(`/co-addresses`, body);
    }

    select(params: any = {}) {
        return super.get(`/co-addresses/select`, params);
    }
}
